<script setup lang="ts">
import camelCase from 'lodash/camelCase';
import { computed } from 'vue';

import Collapse from '@/components/base/layout/Collapse.vue';

const props = defineProps({
  attribute: { required: true, type: String },
  header: { required: true, type: String },
  panelLocator: { required: false, type: String, default: '' },
  showPanel: { required: true, type: Boolean },
});

const showFilters = defineModel<boolean>();

const idBase = computed(() => camelCase(props.header));

const toggleAccordion = () => {
  showFilters.value = !showFilters.value;
};
</script>

<template>
  <div v-show="showPanel" class="panel panel-default">
    <div class="panel-heading" :data-test="`${idBase}FilterHeader`">
      <span
        :aria-controls="`${idBase}Filter`"
        :aria-expanded="showFilters || undefined"
        class="flex"
        :id="`${idBase}FilterHeader`"
        role="button"
        tabindex="0"
        @click="toggleAccordion"
        @keyup.enter="toggleAccordion"
      >
        <strong>{{ header }}</strong>
        <span :class="{ collapsed: !showFilters }" class="collapse-indicator" />
      </span>
    </div>
    <Collapse
      :aria-labelledby="`${idBase}FilterHeader`"
      :data-test="`${idBase}Filter`"
      :expanded="showFilters"
      :id="`${idBase}Filter`"
      tag="section"
    >
      <div class="panel-body" :data-test="panelLocator">
        <slot />
      </div>
    </Collapse>
  </div>
</template>
